export const BASE_SHOPS_PATH = "/shops";
export const MY_ACCOUNTS_FEATURE_PACKAGES = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/account/feature-packages`;
export const STADIUM_FAQ_URL =
  "https://help.bystadium.com/hc/en-us/articles/18686855358615-Understanding-My-Orders-Statuses";
export const CAMPAIGN_INTEGRATE_SALESFORCE_FAQ_URL =
  "https://help.bystadium.com/hc/en-us/articles/32784072747415-How-to-Create-and-Integrate-a-Salesforce-Campaign-with-Stadium-Automated-Gifting";
export const SIGN_UP_PAGE_PARAM = "signUp=true";
export const MY_FUNDS_URL = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/shops/my-funds`;
export const EXT_WALLET_AUTO_REFILL_URL = `${process.env.NEXT_PUBLIC_STADIUM_USERS_URL}/wallet?auto-refill=true`;
export const SAML_METADATA_URL = "https://account.bystadium.com/saml/metadata";

export const ADD_CATALOG_MAIN = `${BASE_SHOPS_PATH}/add-catalog`;
export const ADD_CATALOG_SETUP = `${ADD_CATALOG_MAIN}/upload`;
export const DASHBOARD_HOME_PAGE_URL = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/dashboard`;

const TRACK_SHOP_ORDER = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/shops/orders/:number/track`;
export const getShopTrackOrderRoute = (number) => {
  return TRACK_SHOP_ORDER.replace(":number", number);
};

const TRACK_WORKPSACE_SHOP_ORDER = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/:workspaceSlug/shops/orders/:number/track`;
export const getWorkspaceShopTrackOrderRoute = (number, workspaceSlug) => {
  return TRACK_WORKPSACE_SHOP_ORDER.replace(":workspaceSlug", workspaceSlug).replace(
    ":number",
    number,
  );
};

export const STADIUM_FAVICON_URL = "https://cdn.bystadium.com/mailer_assets/favicon.ico";
export const SWAGMAGIC_FAVICON_URL =
  "https://cdn.bystadium.com/mailer_assets/unify/swag/swagmagic-icon.svg";

export const INTERNAL_DOMAINS = [
  "app.bystadium.com",
  "www.bystadium.com",
  "snackmagic.com",
  "swagmagic.com",
  "superiordishes.com",
];

export const HELP_CENTER_URL = "https://help.bystadium.com/hc/en-us";
export const CONTACT_US =
  "https://help.bystadium.com/hc/en-us/requests/new?ticket_form_id=25244730714391";

export const BYSTADIUM_URL = "https://www.bystadium.com/";
export const CONTACT_US_STADIUM_URL = "https://help.bystadium.com/hc/en-us/requests/new";

export const CORS_ALLOWED_ORIGINS_REGEX =
  /^(https?:\/\/)(.*\.)?(((snackmagic|bystadium|snackmagic-mail|servedbystadium|snack-magic|superiordishes|superiordishes-mail|cpgpulse|swagmagic|stadiumshops|digitalasset|gosteelhead|syftanalytics|regscale|startleftsecurity|thriveal|infogov|clskswag|realcommunity|heyorca|samgi|feetpicsmerch|rbbn|swagbyarmada|guardianrecovery|premiergearstore|nurp|shopcorner-store|inductiveautomation|blacksky|mindex|vistex|dayforcestore|owner|cornerstoneholidayshop|argano|stewardpartners|intrinsicdigital|kellypartners|everhealth|groundtruth|evercommerce|playlist|insights|scalepad|lidoadvisors|docebo|neweratech|nri-na|sabey|butcherbox|cincstore|ocalamarion|stopso|kodekloud|regencycenters|psiquantum|kernandlead)\.com)|(finteract)\.net|(6degrees)\.team|(merchantriskcouncil|rcahybrid|ivyclassical|coeduc|isoc|scrumalliance|nocacademy|marioncelebrates250)\.org|(itelinc|coderabbit)\.shop|(parkermarketing)\.co|(uti)\.edu|(atrium)\.academy|(noxgroup)\.us|(snackdrop)\.app)$/;

/**
 * Validates that a redirect URL's origin matches the CORS allowlist.
 * Relative paths (starting with "/") are always allowed.
 * Returns the fallbackUrl if validation fails.
 */
const isDev = process.env.NODE_ENV === "development";

export const getSafeRedirectUrl = <T extends string | null>(
  url: string | null | undefined,
  fallbackUrl: T,
): string | T => {
  if (!url) return fallbackUrl;

  if (isDev) return url;

  if (url.startsWith("/") && !url.startsWith("//")) return url;

  try {
    const { origin } = new URL(url);
    if (CORS_ALLOWED_ORIGINS_REGEX.test(origin)) return url;
  } catch {
    // malformed URL
  }

  return fallbackUrl;
};

// Note: Any update here needs to be reflected in the Dashboard next.config.js file
export const WORKSPACE_ENABLED_ROUTES = [
  "/dashboard",
  "/admin(/.*){0,}",
  "/recognition(/.*){0,}",
  "/shops/kit-orders(/.*){0,}",
  "/shops/priceless-orders(/.*){0,}",
  "/shops/duplicate-shop(/.*){0,}",
  "/shops/kits(/.*){0,}",
  "/automation-setup(/.*){0,}",
  "/shops/my-orders(/.*){0,}",
  "/automated-gifting(/.*){0,}",
  "/collection/[code]/add-admin",
  "/locker(/.*){0,}",
  "/shops(/.*){0,}",
  "/account/address-book",
  "/account/advanced-options",
  "/account/change-password",
  "/account/contacts",
  "/account/email-preferences",
  "/account/feature-packages",
  "/account/payment-methods",
  "/account/settings",
  "/account/taste-profile",
  "/teams(/.*){0,}",
  "/wallet(/.*){0,}",
  "/contacts-tab(/.*){0,}",
  "/received-gifts",
  "/manage-assets(/.*){0,}",
  "/widget",
];

export const WORKSPACE_DISABLED_ROUTES = ["/shops/login", "/shops/signup"];

export const OLD_STORE_ORDER_REDEMPTION_PAGE_PATHNAME =
  "/[countryCode]/[lang]/orders/[slug]/[[...others]]";
export const STORE_ORDER_REDEMPTION_PAGE_PATHNAME =
  "/[countryCode]-[lang]/orders/[slug]/[[...others]]";

export const OLD_STORE_HOME_PAGE_PATHNAME =
  "/[countryCode]/[lang]/stores/[slug]/[storeNumber]/[[...others]]";
export const STORE_HOME_PAGE_PATHNAME =
  "/[countryCode]-[lang]/stores/[storeIdentifier]/[[...others]]";

export const STORE_WORKSPACE_PATHNAME = "/[countryCode]-[lang]/w/[workspaceSlug]/[[...others]]";

export const NEW_STORE_PATH_WITHOUT_WORKSPACE = "/[countryCode]-[lang]/s/[...others]";

export const OLD_STORE_CREATE_PAGE_PATHNAME =
  "/[countryCode]/[lang]/stores/create/[slug]/[storeNumber]";
export const STORE_CREATE_PAGE_PATHNAME = "/[countryCode]-[lang]/stores/create/[storeIdentifier]";

export const RESTRICTED_ROUTES_FOR_WORKSPACE_SLUG = ["/go/automated-gifting"];

export const WORKSPACE_SLUG = "/[workspaceSlug]";

export const getRoutesWithWorkspaceSlug = () =>
  WORKSPACE_ENABLED_ROUTES.map((route) => `${WORKSPACE_SLUG}${route}`);

export const CREATE_WORKSPACE_PATH = "/create-workspace";
export const CREATE_NEW_WORKSPACE_ROUTE = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}${CREATE_WORKSPACE_PATH}/new/name`;
export const MY_POINTS_WALLET_ROUTE = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/wallet/my-points`;
export const MY_SHOP_POINTS_HISTORY_ROUTE = `${MY_POINTS_WALLET_ROUTE}/shop-points`;

export const getByoShopUrl = ({ shopNumber, workspaceSlug }) =>
  `${process.env.NEXT_PUBLIC_BYSTADIUM_HOSTNAME}/stores/byo-shop--${workspaceSlug}/${shopNumber}`;

export const STADIUM_GIFT_SHOP_URL = process.env.NEXT_PUBLIC_STADIUM_GIFT_SHOP_URL;

export const CONTACTS_ROUTE = `${WORKSPACE_SLUG}/contacts-tab`;
export const CONTACTS_MANAGE_PERMISSIONS_ROUTE = `${CONTACTS_ROUTE}/manage-permissions`;
export const SWAG_CREATION_ROUTE = "/w/[workspaceSlug]/design/swag/[[...others]]";

export const SHOP_CATALOG_PATH_SUFFIX = "/all-products";
export const MY_DESIGN_SWAG_PATH_SUFFIX = "/locker-my-designed-swag";
